import { ref, getCurrentInstance } from "@vue/composition-api";

export function useDeviceMessages(translations) {
  const loading = ref(false);
  const vm = getCurrentInstance();
  const proxy = vm.root.proxy;

  const replacePlaceholders = (template, values) => {
    if (!template) return '';
    return template.replace(/%(\w+)%/g, (match, key) => {
      return values.hasOwnProperty(key) ? values[key] : match;
    });
  }

  const confirmActionAlert = async (device, action = null) => {
    const $swal = proxy?.$swal;
    if (!$swal) return;

    const titleSwal = getTitleSwal(device, action);
    const confirmButton = getTitleConfirmButton(device, action);

    return await $swal({
      title: titleSwal,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: confirmButton,
      cancelButtonText: translations["actions.cancel"],
      customClass: {
        confirmButton: "btn btn-primary text-capitalize",
        cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
      },
      buttonsStyling: false,
    });
  };

  const successAlertAction = async function (device, action = null) {
    const $swal = proxy?.$swal;
    if (!$swal) return;

    let { device_type, status, text } = device;
    let titleConfirm = '';
    let textConfirm = '';

    if (device_type === 'area') {
      if (status === 'ARMED') {
        titleConfirm = translations["messages.desactivate.disarmed_correctly"]
      } else if (status === 'BURGLARY') {
        titleConfirm = translations["messages.desactivate.disarmed_correctly"]
      } else {
        titleConfirm = translations["messages.activate.armed_correctly"];
      }
    } else {
      titleConfirm = replacePlaceholders(
        translations["dmp.messages.commandExecutedSuccess"],
        { command: translations[action.name] || action.name }
      );
    }

    await $swal({
      title: titleConfirm,
      text: textConfirm,
      icon: "success",
    });
  }

  const errorAlertAction = async function (device, message = null) {
    const $swal = proxy?.$swal;
    if (!$swal) return;

    const messageError = message || (device.active
      ? translations["messages.desactivate.error"]
      : translations["messages.activate.error"]);

    const htmlMessage = formatMessage(messageError);
    return await $swal({ title: 'Error', html: htmlMessage, icon: "error" });
  }

  function formatMessage(message) {
    const colonIndex = message.indexOf(':');

    if (colonIndex === -1) return message;

    const prefix = message.slice(0, colonIndex + 1).trim();
    const rest = message.slice(colonIndex + 1).trim();

    const items = rest
      .split(',')
      .map(z => z.trim())
      .filter(Boolean);

    if (!items.length) return message;

    const listHtml = items.map(z => `<li>${z}</li>`).join('');

    return `${prefix}<ul style="text-align:center; margin-top:8px; padding-left:20px; list-style:none;"${listHtml} </ul>`;
  }

  const showToast = (status, device, loadingToast) => {
    const message = translations["messages.processing"];

    if (loadingToast) {
      loadingToast.show(translations["messages.loading.title"], `${message} ${device.text}`, "secondary");
    }
  };

  const getTitleSwal = (device, action = null) => {
    let { status, device_type, text } = device;
    let isAreaDevice = (device_type === 'area');
    let isOutputDevice = (device_type === 'output');
    let deviceType = translations[device_type];

    let placeholders = {
      action: '',
      device_type: deviceType,
      device: text
    }


    placeholders.action = (action) ? (translations[action.name] || action.name) : '';

    if (isAreaDevice) {
      placeholders.action = (status === 'ARMED' || 'BURGLARY') ? translations['disarm'] : translations['arm'];
    } else if (isOutputDevice) {
      placeholders.device_type = '';
    }

    return replacePlaceholders(
      translations["dmp.messages.areYouSure"],
      placeholders
    )
  };

  const getTitleConfirmButton = (device, action = null) => {
    return device.status === "enabled"
      ? translations["messages.desactivate.confirm"]
      : translations["messages.activate.confirm"];
  };

  const confirmArmAlert = async (device, action = null) => {
    const $swal = proxy?.$swal;
    if (!$swal) return;

    const titleSwal = getTitleSwal(device, action);
    const confirmButton = getTitleConfirmButton(device, action);

    return await $swal({
      title: titleSwal,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: confirmButton,
      cancelButtonText: translations["actions.cancel"],
      customClass: {
        confirmButton: "btn btn-primary text-capitalize",
        cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
      },
      buttonsStyling: false,
      html: `
        <div class="d-flex flex-column align-items-start px-1 w-100">
          <label class="mb-50 font-weight-bold">${translations["dmp.badZones"] || "Bad Zones"}</label>
          <select id="armModeSelect" class="form-control mb-5">
          <option value='refuse'>${translations["dmp.refuse"] || "Refuse"}</option>
          <option value='bypass'>${translations["dmp.bypass"] || "Bypass"}</option>
          <option value='force'>${translations["dmp.force"] || "Force"}</option>
          </select>
        </div>
      `,
      preConfirm: () => {
        const selected = document.getElementById('armModeSelect');
        return selected ? selected.value : null;
      },
    });
  };

  return {
    confirmActionAlert,
    successAlertAction,
    errorAlertAction,
    showToast,
    confirmArmAlert,
    loading
  };
}
